<template>
    <v-container fluid class="incidente-root">
        <v-card class="pa-4" elevation="2">
            <v-row align="center">
                <v-col cols="12" md="6">
                    <h2>Administración de Catálogos</h2>
                </v-col>
                <v-col cols="12" md="6" class="text-right">
                    <v-btn class="perfil-btn-primary mr-2" dark @click="nuevoTipo">
                        <v-icon left>mdi-plus</v-icon>Nuevo tipo
                    </v-btn>
                    <v-btn class="perfil-btn-primary" dark @click="nuevoItem">
                        <v-icon left>mdi-plus</v-icon>Nuevo ítem
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar ítem" outlined dense clearable/>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select v-model="filtroTipo" :items="tiposFiltro" item-text="nombre" item-value="oid" label="Filtrar por tipo de catálogo" outlined dense clearable/>
                </v-col>
            </v-row>

            <v-tabs v-model="tab" background-color="transparent" color="#5e672c">
                <v-tab>Tipos</v-tab>
                <v-tab>Ítems</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <!-- TIPOS -->
                <v-tab-item>
                    <v-data-table :headers="headersTipos" :items="tiposFiltrados" item-key="oid" :items-per-page="20">
                        <template v-slot:item.activo="{ item }">
                            <v-chip small :color="item.activo ? 'green' : 'red'" dark>
                                {{ item.activo ? 'Activo' : 'Inactivo' }}
                            </v-chip>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <!-- <v-icon small class="mr-2" @click="editarTipo(item)">mdi-pencil</v-icon> -->
                            <!-- <v-icon small color="red" @click="confirmarEliminar('tipo', item.oid)">mdi-delete</v-icon> -->
                            <v-icon small :color="item.activo ? 'red' : 'green'" @click="confirmarCambiarEstado('tipo', item)">
                                {{ item.activo ? 'mdi-close-circle' : 'mdi-check-circle' }}
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-tab-item>
                <!-- ITEMS -->
                <v-tab-item>
                    <v-data-table :headers="headersItems" :items="itemsFiltrados" item-key="oid" :items-per-page="30">
                        <template v-slot:item.tipoNombre="{ item }">
                            {{ getTipoNombre(item.oid_tipo) }}
                        </template>
                        <template v-slot:item.activo="{ item }">
                            <v-chip small :color="item.activo ? 'green' : 'red'" dark>
                                {{ item.activo ? 'Activo' : 'Inactivo' }}
                            </v-chip>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="editarItem(item)">mdi-pencil</v-icon>
                            <!-- <v-icon small color="red" @click="confirmarEliminar('item', item.oid)">mdi-delete</v-icon> -->
                            <v-icon small :color="item.activo ? 'red' : 'green'" @click="confirmarCambiarEstado('item', item)">
                                {{ item.activo ? 'mdi-close-circle' : 'mdi-check-circle' }}
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <!-- DIALOG TIPO -->
        <v-dialog v-model="dialogTipo" max-width="600px" persistent>
            <v-card>
                <v-card-title>
                    <v-icon left color="#5e672c">mdi-folder-cog-outline</v-icon>
                        {{ isNewTipo ? 'Crear tipo' : 'Actualizar tipo' }}
                    <v-spacer />
                    <v-btn icon @click="dialogTipo = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="formTipo" v-model="formTipoValid" lazy-validation>
                        <v-text-field v-model="tipo.codigo" label="Código" :rules="[rules.required]" outlined dense />
                        <v-text-field v-model="tipo.nombre" label="Nombre" :rules="[rules.required]" outlined dense />
                        <v-switch v-model="tipo.activo" label="Activo" color="#5e672c" />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer />
                    <v-btn text @click="dialogTipo = false">Cancelar</v-btn>
                    <v-btn class="perfil-btn-primary" :loading="guardando" :disabled="!formTipoValid || guardando" @click="guardarTipo"> Guardar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- DIALOG ITEM -->
        <v-dialog v-model="dialogItem" max-width="700px" persistent>
            <v-card>
                <v-card-title>
                    <v-icon left color="#5e672c">mdi-format-list-bulleted-type</v-icon>
                        {{ isNewItem ? 'Crear ítem de catálogo' : 'Actualizar ítem de catálogo' }}
                    <v-spacer />
                    <v-btn icon @click="dialogItem = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="formItem" v-model="formItemValid" lazy-validation>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select v-model="item.oid_tipo" :items="tiposActivos" item-text="nombre" item-value="oid" label="Tipo de catálogo" :rules="[rules.required]" outlined dense/>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="item.nombre" label="Nombre" :rules="[rules.required]" outlined dense />
                            </v-col>
                            <v-col cols="12" md="8">
                                <v-text-field v-model="item.descripcion" label="Descripción" outlined dense />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model.number="item.orden" label="Orden" type="number" outlined dense/>
                            </v-col>
                            <v-col cols="12">
                                <v-switch v-model="item.activo" label="Activo" color="#5e672c" />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogItem = false">Cancelar</v-btn>
                    <v-btn class="perfil-btn-primary" :loading="guardando" :disabled="!formItemValid || guardando" @click="guardarItem">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- CONFIRMAR ELIMINAR -->
        <v-dialog v-model="dialogEliminar" max-width="450px">
            <v-card>
                <v-card-title>
                    {{ registroEstado?.activo ? 'Confirmar inactivación' : 'Confirmar activación' }}
                </v-card-title>
                <v-card-text>
                    ¿Está seguro de <strong>{{ registroEstado?.activo ? 'inactivar' : 'activar' }}</strong> este registro?
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogEliminar = false">Cancelar</v-btn>
                    <v-btn :color="registroEstado?.activo ? 'red' : 'green'" dark @click="cambiarEstado">
                        {{ registroEstado?.activo ? 'Inactivar' : 'Activar' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="4000" top>
            {{ snackbarMensaje }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from "axios";

export default {
    name: "AdmCatalogos",

    data() {
        return {
            tab: 0, tipos: [], items: [],
            search: "", filtroTipo: null,
            dialogTipo: false, dialogItem: false, dialogEliminar: false,
            isNewTipo: true, isNewItem: true,
            guardando: false,
            tipo: {
                oid: 0,
                codigo: "",
                nombre: "",
                activo: true
            },
            item: {
                oid: 0,
                oid_tipo: null,
                nombre: "",
                descripcion: "",
                orden: null,
                activo: true
            },
            eliminarTipoRegistro: "", eliminarId: null,
            formTipoValid: false, formItemValid: false,
            snackbar: false,
            snackbarMensaje: "",
            snackbarColor: "success",
            rules: {
                required: v => v !== null && v !== undefined && v !== "" || "Requerido"
            },
            headersTipos: [
                { text: "Acciones", value: "actions", sortable: false },
                { text: "Código", value: "codigo" },
                { text: "Nombre", value: "nombre" },
                { text: "Activo", value: "activo" }
            ],
            headersItems: [
                { text: "Acciones", value: "actions", sortable: false },
                { text: "Tipo", value: "tipoNombre" },
                { text: "Nombre", value: "nombre" },
                { text: "Descripción", value: "descripcion" },
                { text: "Orden", value: "orden" },
                { text: "Activo", value: "activo" }
            ],
            registroEstado: null,
            tipoRegistroEstado: "",
        };
    },
    computed: {
        tiposActivos() {
            return this.tipos.filter(x => x.activo);
        },
        tiposFiltro() {
            return [
                { oid: null, nombre: "Todos" },
                ...this.tipos
            ];
        },
        tiposFiltrados() {
            const texto = this.normalizar(this.search);

            return this.tipos.filter(x => {
                const coincideTexto =
                !texto ||
                this.normalizar(x.nombre).includes(texto) ||
                this.normalizar(x.codigo).includes(texto);

                return coincideTexto;
            });
        },
        itemsFiltrados() {
            const texto = this.normalizar(this.search);

            return this.items.filter(x => {
                const coincideTipo =
                !this.filtroTipo || Number(x.oid_tipo) === Number(this.filtroTipo);

                const coincideTexto =
                !texto ||
                this.normalizar(x.nombre).includes(texto) ||
                this.normalizar(x.descripcion).includes(texto) ||
                this.normalizar(this.getTipoNombre(x.oid_tipo)).includes(texto);

                return coincideTipo && coincideTexto;
            });
        }
    },
    mounted() {
        this.listar();
    },
    methods: {
        async listar() {
            try {
                const [resTipos, resItems] = await Promise.all([
                axios.get("api/CatalogoTipoes/Listar"),
                axios.get("api/CatalogoItems/Listar")
                ]);

                this.tipos = resTipos.data || [];
                this.items = resItems.data || [];
            } catch (error) {
                console.error(error);
                this.mostrarMensaje("Error al cargar catálogos", "error");
            }
        },
        nuevoTipo() {
            this.tipo = {
                oid: 0,
                codigo: "",
                nombre: "",
                activo: true
            };

            this.isNewTipo = true;
            this.dialogTipo = true;

            this.$nextTick(() => {
                this.$refs.formTipo && this.$refs.formTipo.resetValidation();
                this.formTipoValid = false;
            });
        },
        editarTipo(tipo) {
            this.tipo = { ...tipo };
            this.isNewTipo = false;
            this.dialogTipo = true;

            this.$nextTick(() => {
                this.$refs.formTipo && this.$refs.formTipo.resetValidation();
            });
        },
        nuevoItem() {
            this.item = {
                oid: 0,
                oid_tipo: this.filtroTipo || null,
                nombre: "",
                descripcion: "",
                orden: null,
                activo: true
            };

            this.isNewItem = true;
            this.dialogItem = true;

            this.$nextTick(() => {
                this.$refs.formItem && this.$refs.formItem.resetValidation();
                this.formItemValid = false;
            });
        },
        editarItem(item) {
            this.item = { ...item };
            this.isNewItem = false;
            this.dialogItem = true;

            this.$nextTick(() => {
                this.$refs.formItem && this.$refs.formItem.resetValidation();
            });
        },
        async guardarTipo() {
            const ok = this.$refs.formTipo && this.$refs.formTipo.validate();
            if (!ok) return;

            this.guardando = true;

            try {
                const payload = {
                    ...this.tipo,
                    codigo: this.tipo.codigo.trim(),
                    nombre: this.tipo.nombre.trim()
                };

                if (this.isNewTipo) {
                    await axios.post("api/CatalogoTipoes/Crear", payload);
                } else {
                    await axios.put("api/CatalogoTipoes/Actualizar", payload);
                }

                this.dialogTipo = false;
                await this.listar();
                this.mostrarMensaje("Tipo de catálogo guardado correctamente", "success");
            } catch (error) {
                console.error(error);
                this.mostrarMensaje("Error al guardar tipo de catálogo", "error");
            } finally {
                this.guardando = false;
            }
        },
        async guardarItem() {
            const ok = this.$refs.formItem && this.$refs.formItem.validate();
            if (!ok) return;

            this.guardando = true;

            try {
                const payload = {
                    ...this.item,
                    nombre: this.item.nombre.trim(),
                    descripcion: this.item.descripcion || null,
                    orden: this.item.orden || null
                };

                if (this.isNewItem) {
                    await axios.post("api/CatalogoItems/Crear", payload);
                } else {
                    await axios.put("api/CatalogoItems/Actualizar", payload);
                }

                this.dialogItem = false;
                await this.listar();
                this.mostrarMensaje("Ítem guardado correctamente", "success");
            } catch (error) {
                console.error(error);
                this.mostrarMensaje("Error al guardar ítem", "error");
            } finally {
                this.guardando = false;
            }
        },
        confirmarEliminar(tipoRegistro, id) {
            this.eliminarTipoRegistro = tipoRegistro;
            this.eliminarId = id;
            this.dialogEliminar = true;
        },
        async eliminar() {
            try {
                if (this.eliminarTipoRegistro === "tipo") {
                await axios.delete(`api/CatalogoTipoes/Eliminar/${this.eliminarId}`);
                } else {
                await axios.delete(`api/CatalogoItems/Eliminar/${this.eliminarId}`);
                }

                this.dialogEliminar = false;
                await this.listar();
                this.mostrarMensaje("Registro eliminado correctamente", "success");
            } catch (error) {
                console.error(error);
                this.mostrarMensaje("No se pudo eliminar el registro", "error");
            }
        },
        getTipoNombre(id) {
            const tipo = this.tipos.find(x => Number(x.oid) === Number(id));
            return tipo ? tipo.nombre : "Sin tipo";
        },
        normalizar(texto) {
            return String(texto || "")
                .trim()
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
        },
        mostrarMensaje(mensaje, color) {
            this.snackbarMensaje = mensaje;
            this.snackbarColor = color;
            this.snackbar = true;
        },
        confirmarCambiarEstado(tipoRegistro, item) {
            this.tipoRegistroEstado = tipoRegistro;
            this.registroEstado = { ...item };
            this.dialogEliminar = true;
        },
        async cambiarEstado() {
            if (!this.registroEstado) return;

            this.guardando = true;

            try {
                const payload = {
                    ...this.registroEstado,
                    activo: !this.registroEstado.activo
                };

                if (this.tipoRegistroEstado === "tipo") {
                    await axios.put("api/CatalogoTipoes/Actualizar", payload);
                } else {
                    await axios.put("api/CatalogoItems/Actualizar", payload);
                }

                this.dialogEliminar = false;
                this.registroEstado = null;
                this.tipoRegistroEstado = "";

                await this.listar();

                this.mostrarMensaje(
                payload.activo
                    ? "Registro activado correctamente"
                    : "Registro inactivado correctamente",
                "success"
                );
            } catch (error) {
                console.error(error);
                this.mostrarMensaje("No se pudo actualizar el estado del registro", "error");
            } finally {
                this.guardando = false;
            }
        },
    }
};
</script>

<style>
    p {
        font-family: 'Gotham', !important;
    }
    h1 {
        font-family: 'Gotham', !important;
    }

    .incidente-root {
        padding-top: 0 !important;
        margin-top: 0 !important;
        width: 100% !important;
        align-self: flex-start !important;
        margin-left: 1%;
    }
</style>